const type = 'advanced'
const path = '/advance/3ds-node/public/'
const name = 'server.js'

const conditions = [
  {
    option: 'frontend',
    type: 'equals',
    value: 'html',
  },
  {
    parameter: 'buttons',
    type: 'includes',
    value: 'payment-buttons_3ds',
  },
]

export { type, path, name, conditions }
